/**
 * UranIA PA — `/accesso-negato` (403 esplicito).
 *
 * Fuori dai quattro segmenti pathless (nessuna guardia propria — vedi
 * `features/sistema/AccessoNegatoPage.tsx`): è la destinazione a cui
 * *altre* guardie possono mandare esplicitamente, non un'area con un
 * proprio insieme di ruoli ammessi.
 */

import { createRoute } from '@tanstack/react-router';

import { AccessoNegatoPage } from '../features/sistema/AccessoNegatoPage.tsx';
import { Route as RootRoute } from './__root.tsx';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/accesso-negato',
  component: AccessoNegatoPage,
});
